<template lang="pug">
    v-card-text
        v-layout(row wrap align-start)
            v-flex(md5 sm5 offset-md1)
                span.title Subfamilia:
            v-flex(md5 sm5)
                span.title {{name}}
        // v-layout.separated(row wrap align-start v-if="maxPriceDiscount!=null")
            v-flex(md5 sm5 offset-md1)
                span.title Precio sin descuento:
            v-flex(md5 sm5)
                span.title $ {{maxPriceDiscount.toLocaleString('es')}}
</template>

<script>
// Services:
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'

// Mixins:
import CurrencyUtils from '@/mixins/CurrencyUtils'
import { mapActions, mapState } from 'vuex';
export default {
    name: 'subfamily-data',
    props: {},
    data: function(){
        return {
            name: '',
            // price: '',
        }
    },
    computed: {
        ...mapState('WholesaleDiscountModule',{
            maxPriceDiscount: 'maxPriceDiscount'
        }),
    },
    methods: {
        ...mapActions('WholesaleDiscountModule',{
            setMaxPriceDiscount: 'setMaxPriceDiscount',
            setId: 'setId',
        }),
    },
    watch: {},
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function(){

        let idSubfamily = this.$route.params.id
        let subfamilyData = await SubfamilyService.fetchSubfamily(idSubfamily)
        
        this.name = subfamilyData.subfamily
        // this.setId(idSubfamily)
        // this.setMaxPriceDiscount(100)
        // TODO: poner numero de sucursal ---^
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    .separated {
        margin-top: 10px;
    }
</style>